import { Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

const GOOGLEAPI = 'https://maps.googleapis.com/maps/api/geocode/json?';
const GOOGLEMAPS = `${GOOGLEAPI}`;
const GOOGLEREVERSE = `${GOOGLEAPI}`;

// Test endpoint
// return Observable.of(GOOGLEADDRESS);
// return Observable.of(REVERSELOOKUP);

export class AddressLookUpServiceConfig {
    apiKey = '';
}

@Injectable()
export class InputAddressLookUpService {
    apiKey = '';
    country = '';

    constructor(
        private http: HttpClient,
        @Optional() config: AddressLookUpServiceConfig
    ) {
        if (config) {
            this.apiKey = config.apiKey;
        }
    }

    getAddresses(address: Observable<string>, country = ''): Observable<any> {
        this.country = country;

        return address.pipe(
            debounceTime(250),
            distinctUntilChanged(),
            filter(addData => addData !== ''),
            switchMap(add => {
                return this.http.get(`${GOOGLEMAPS}&key=${this.apiKey}&address=${add}&components=country:${this.country}`);
            }));
    }

    reverseAddressLookUp(latLng: { latitude: number; longitude: number }): Observable<any> {
        return this.http.get(`${GOOGLEREVERSE}key=${this.apiKey}&latlng=${latLng.latitude},${latLng.longitude}`);
    }
}
